import type { User } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/admin/users/utils/fields';

const fields: FormItem<User>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'User Details',
    items: [allFields.groups],
  },
  {
    cssClass: 'tmm-section tmm-section-no-caption',
    colCount: 2,
    items: [
      { ...allFields.name, colSpan: 1 },
      { ...allFields.role, colSpan: 1 },
      { ...allFields.phone, colSpan: 1 },
      { ...allFields.email, colSpan: 1 },
      { ...allFields.address, colSpan: 2 },
    ],
  },
];

export default fields;
